import React from "react";
import arrow from "../../assets/imgs/icons/arrow.svg";
import bags from "../../assets/imgs/bags.jpg";
import dresses from "../../assets/imgs/dresses.jpg";
import skirts from "../../assets/imgs/skirts.jpg";
import exploreMre from "../../assets/imgs/explore-more.jpg";
import { useNavigate } from "react-router-dom";
import "./HomeAllProducts.css";
import { motion } from "framer-motion";

const products = [
  { img: bags, label: "BAGS", catId: "Bags" },
  { img: dresses, label: "DRESSES", catId: "Dresses" },
  { img: skirts, label: "SKIRTS", catId: "Skirts" },
  { img: exploreMre, label: "EXPLORE MORE", catId: "EXPLORE_MORE" },
];


const Card = ({ img, label, catId, index, handleClick }) => (
  <motion.a
    className="card"
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{
      duration: 1,
      ease: "easeOut",
      delay: index < 2 ? index * 0.2 : 0.6, 
      
    }}
    onClick={() => handleClick(catId)}
  >
    <div className="card-img-wrapper">
      <img src={img} alt={label} />
    </div>
    <div className="card-text">{label}</div>
  </motion.a>
);

function HomeAllProducts({ onProductCatClick }) {
  const navigate = useNavigate();

  const handleClick = (catId) => {
    if (catId === "EXPLORE_MORE") {
    
      onProductCatClick();
    } else {
  
      navigate(`/Product/${catId}`);
    }
  };
  return (
    
    <motion.div
      className="hoPrdts"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="maxW">
        <div className="hoHd">
          <h5>VIEW ALL PRODUCTS </h5>
        </div>
        <div className="img-con">
          <motion.div
            className="proWrap"
            initial="hidden"
            whileInView="visible"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: {
                opacity: 1,
                y: 0,
                transition: { staggerChildren: 0.2, duration: 2, ease: "easeOut" },
              },
            }}
            viewport={{ once: false }}
          >
            {products.map((product, index) => (
              <Card key={index} {...product}  handleClick={handleClick}/>
            ))}
          </motion.div>
        </div>
      </div>
    </motion.div>
    

    
  );
}

export default HomeAllProducts;
